import React, { useState } from 'react';
import { Box, Flex, Text, Input, InputGroup, InputRightElement, Button } from '@chakra-ui/react';
import axios from '../../lib/axios';
import { useToast } from '@chakra-ui/react';

function Newsletter() {
  const [email, setEmail] = useState(''); 
  const toast = useToast();

  const handleSubscribe = () => {
    axios.post(`/User/join-waitlist?email=${email}`)
      .then((response) => {
        if (response.data.success) {
          toast({
            title: 'Subscribed to our newsletter',
            description: response.data.message,
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          setEmail('');
        }
        else {
          toast({
            title: 'Failed to subscribe',
            description: response.data.message,
            status: 'warning',
            duration: 3000,
            isClosable: true,
          });
        
        }
      })
      .catch((error) => {
        console.error(error);
        toast({
          title: 'Failed to subscribe',
          description: 'There was an error subscribing to our newsletter. Please try again later.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      });
  };

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      justifyContent="center"
      alignItems="center"
      py={{ base: '6', md: '8' }} // Aumenta padding vertical
      px={{ base: '4', md: '6' }} // Padding horizontal
      bg="teal.100" // Ajusta según tu paleta de colores
      borderRadius="md"
      id="Newletter"
    >
      {/* Contenedor para el título y el texto */}
      <Box maxW="600px" w="full" mb={{ base: 4, md: 0 }} px={2}>
        <Text
          color="#303030"
          fontFamily="Quicksand"
          fontSize="32px"
          fontWeight="700"
          lineHeight="41px"
          mb="10px"
        >
          Join the Waitlist!
        </Text>
        <Text
          color="#303030"
          fontFamily="Quicksand"
          fontSize="16px"
          fontWeight="500"
          lineHeight="25px"
          letterSpacing="0.08px"
        >
          Spark joy in learning 🌟 Join our waitlist to get the latest updates on our launch and upcoming features.🚀
        </Text>
      </Box>

      {/* Contenedor para el formulario */}
      <Box maxW="600px" w="full" px={2}>
        <InputGroup size="lg">
          <Input
            type="email"
            placeholder="Enter your email"
            borderRadius="12px"
            background="rgba(255, 255, 255, 0.85)"
            paddingLeft="19px"
            height="56px"
            opacity="85%"
            _placeholder={{
              color: "#48555F",
              fontFamily: "Quicksand",
              fontSize: "17px",
              fontWeight: "600",
              lineHeight: "25px",
            }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}

          />
          <InputRightElement width="6rem" height="56px">
            <Button
              size="sm"
              borderRadius="0 8px 8px 0" // Redondea solo las esquinas derechas del botón
              height="100%" // Asegúrate de que el botón llene el addon verticalmente
              width="100%" // Asegúrate de que el botón llene el addon horizontalmente
              background="transparent"
              _hover={{ bg: 'teal.200' }}
              _active={{ bg: 'teal.300' }}
              opacity="100%"
              onClick={handleSubscribe}
            >
              🚀 Join TEA 
            </Button>
          </InputRightElement>
        </InputGroup>
      </Box>
    </Flex>
  );
}

export default Newsletter;
